export default __webpack_public_path__ + "static/justbeastin-FINALUnivRed-cfd3b6b17c05a1594da5b4d14e4f388f.png";